import Vue from 'vue'
import commentMixin from './comment-mixin'

import withRender from './comment.html'
import 'objects/byline/byline.scss'
import './comment.scss'

const ELAPSED_DATE_TYPE = 'ed'
const FORMATTED_DATE_TYPE = 'fd'
const CAT_ITEM_TYPE = 'ci'
const META_TYPES = [ELAPSED_DATE_TYPE, FORMATTED_DATE_TYPE, CAT_ITEM_TYPE]

/**
 * Used for top-comments (ed), comments-question (fd), profile comment (ci)
 */
export default withRender(Vue.extend({
  props: {
    metaType: {
      type: String,
      validator: value => META_TYPES.indexOf(value) > -1
    },
    prefixText: String // for top comment
  },
  mixins: [commentMixin],
  computed: {
    dateText() {
      return this.metaType === FORMATTED_DATE_TYPE ? this.comment.dateCreatedFormatted :
        this.$msg('comment.purchased', [this.elapsedTime])
    },
    linkUsername() {
      // TODO: when my posts is released, this can be uncommented instead of using false
      return false // this.metaType === FORMATTED_DATE_TYPE
    },
    showCatItem() {
      return this.metaType === CAT_ITEM_TYPE
    }
  },
  methods: {
    showProfile() {
      // TODO
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/comment/comment.ts